var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"m5 10h30v3.4h-30v-3.4z m0 11.6v-3.2h30v3.2h-30z m0 8.4v-3.4h30v3.4h-30z"})));
}

Hamburger.defaultProps = {"fill":"currentColor","preserveAspectRatio":"xMidYMid meet","height":"32","width":"32","viewBox":"0 0 40 40","style":{"verticalAlign":"middle","color":"white"}};

module.exports = Hamburger;

Hamburger.default = Hamburger;
